import { rupiah } from '@/lib/format';
import { cn } from '@/lib/utils';

interface MoneyValueProps {
  value: number | null | undefined;
  /** Gold emphasis for totals / the number that matters. */
  emphasis?: boolean;
  /** Strikethrough (e.g. original price beside a discount). */
  strike?: boolean;
  className?: string;
}

/** The single money primitive — tabular, optional gold emphasis. */
export function MoneyValue({ value, emphasis, strike, className }: MoneyValueProps) {
  return (
    <span
      className={cn(
        'tnum font-display tracking-tight',
        emphasis ? 'money font-bold' : 'text-foreground',
        strike && 'text-ink-400 line-through decoration-ink-400/60',
        className,
      )}
    >
      {rupiah(value)}
    </span>
  );
}
